<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->


    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="banner-title-name-new" title="Mindfulness Practices for Schools: Helping Students Stay Focused." subtitle="Mindfulness Practices for Schools: Helping Students Stay Focused."></app-page-banner>
        <!-- INNER PAGE BANNER END -->

        <!-- OUR BLOG START -->
        <div class="section-full  p-t120 p-b90 bg-white">
            <div class="container">

                <!-- BLOG SECTION START -->
                <div >
                    <div class="row d-flex justify-content-center mobilerow">

                        <div class="blog-post blog-post-4-outer m-b30" >
                            <!-- <div class="wt-post-title ">
                                <h4 class="post-title"><a routerLink="javascript:void(0)">Why Mental Health Should Be a Priority in Schools</a></h4>
                            </div> -->
                            <div>
                               <p style="font-style: italic;font-size: 23px;">Mindfulness isn’t about eliminating distractions—it’s about learning to focus
                                through them.</p>

                                     
                                        <p style="font-size: 23px;">
                                            Students today face endless distractions, from gadgets to social media. Mindfulness
                                            offers a way to stay present, improve focus, and reduce stress, making it a valuable
                                            tool for schools to adopt.
                                        </p>
                                       
                            </div>
                           

                            <div class="wt-post-media wt-img-effect zoom-slow" style="margin-top: 15px;">
                                <a routerLink="javascript:void(0)"><img src="assets/images/happy-schoolchildren-in-formal-wear-holding-cards-2024-11-17-07-45-42-utc.jpg" alt=""></a>
                            </div>
                            <div class="wt-post-info mobcon">
                                <!-- <div class="wt-post-meta ">
                                    <ul>
                                        <li class="post-date"><span>{{blog.day}}</span>{{blog.month}}</li>
                                        <li class="post-category">{{blog.field}}</li>
                                    </ul>
                                </div> -->
                                
                                <div class="wt-post-text ">
                          
                                    <h6 class="post-title"> <a routerLink="javascript:void(0)">Benefits of Mindfulness:</a></h6>
                                    <ul style="margin-left: 56px; ">    
                                        <li style="margin-left: 56px; ">Improved Focus and Academic Performance</li>
                                        <li style="margin-left: 56px; ">Reduced Anxiety and Stress</li>
                                        <li style="margin-left: 56px; ">Better Emotional Awareness</li>

                                    </ul>
                        
                                      
                                                <h6 class="post-title"> <a routerLink="javascript:void(0)">Mindfulness Activities for Schools:</a></h6>
                                            <h6 class="post-title"  style="margin-left: 31px; font-size: 21px !important;"> <a routerLink="javascript:void(0)">1. Mindful Breathing</a></h6>
                                            <p style="margin-left: 56px; ">Start the day with 2-3 minutes of guided breathing exercises.</p>
                                        <h6 class="post-title"  style="margin-left: 31px; font-size: 21px !important;"> <a routerLink="javascript:void(0)">2. Gratitude Journals</a></h6>
                                        <p style="margin-left: 56px; ">Encourage students to write down three things they’re grateful for each day.</p>
                                        <h6 class="post-title"  style="margin-left: 31px; font-size: 21px !important;"> <a routerLink="javascript:void(0)">3. Mindful Listening</a></h6>
                                        <p style="margin-left: 56px; ">Use classroom activities where students focus entirely on one sound or voice.</p>
                                       
                                        <h6 class="post-title"> <a routerLink="javascript:void(0)">How Soul Space Can Help?</a></h6>
                                        <p style="font-size: 23px;">Our mindfulness programs are tailored to fit into school schedules, offering students
                                            tools to build resilience and focus. <a href="javascript:void(0);" routerLink="/contact" style="color: #007bff !important;">Bring Mindfulness to Your School</a> today. </p>
                                       
                                </div>
                                <!-- <div class="wt-post-readmore ">
                                    <a routerLink="javascript:void(0)" class="site-button-link black">Read More</a>
                                </div> -->
                            </div>
                        
                            
                        </div>

                        <!-- SIDE BAR START -->
           
                        <!-- SIDE BAR END -->


                    </div>

                </div>

            </div>

        </div>
        <!-- OUR BLOG END -->


    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>

</div>

<app-loader></app-loader>